import { useEffect, useState } from 'react';
import { useReduxStore } from '../../../hooks/useReduxStore';
import { GetApiKeysAction } from '../../../store/Actions/adminActions';
import { useNavigate } from 'react-router-dom';

export default function useApiKeysManagement() {
  const { getState, dispatch } = useReduxStore();
const navigate=useNavigate()
  // Get data from store
  const { 
    apiKeys, 
    totalApiKeys, 
    currentPage, 
    totalPages, 
    filters, 
    loading, 
    isError, 
    errorMessage 
  } = getState("ADMIN_API_KEYS_MANAGEMENT");

  // Local state for filters
  const [localFilters, setLocalFilters] = useState({
    search: '',
    status: '',
    page: 1,
    limit: 10,
  });

  // Fetch API keys when component mounts or filters change
  useEffect(() => {
    let {search, status, page, limit} = localFilters;
    let params = {
      page: page || 1,
      limit: limit || 10
    }
    
    if(search?.length) params.search = search;
    if(status?.length) params.status = status;
  console.log("params-----------",params)
    console.log("Fetching API keys with params:", params);
    dispatch(GetApiKeysAction(params));
  }, [localFilters, dispatch]);

  // Set filters function
  const setFilters = (newFilters) => {
    setLocalFilters(prev => ({
      ...prev,
      ...newFilters,
      page: 1, // Reset to first page when filters change
    }));
  };

  // Set current page function
  const setCurrentPage = (page) => {
    setLocalFilters(prev => ({
      ...prev,
      page,
    }));
  };

  // Search API keys function
  const searchApiKeys = (searchTerm) => {
    setFilters({ search: searchTerm });
  };

  // Clear filters function
  const clearFilters = () => {
    setLocalFilters({
      search: '',
      status: '',
      page: 1,
      limit: 10,
    });
  };

  // View API key detail function
  const viewDetail = (apiKey) => {
    navigate("/Admin/Dashboard/APIKeys/Detail",{state:{apiKeyId:apiKey?.id}})
    // TODO: Implement view detail functionality
  };

  // Status options
  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' },
  ];

  return {
    apiKeys: apiKeys || [],
    loading,
    totalApiKeys: totalApiKeys || 0,
    currentPage: currentPage || 1,
    totalPages: totalPages || 1,
    filters: localFilters,
    setFilters,
    setCurrentPage,
    searchApiKeys,
    clearFilters,
    viewDetail,
    statusOptions,
    isError,
    errorMessage,
  };
}
